/*
 * The light/dark switch, in the header of both shells.
 *
 * It started at the right-hand end of the footer (S38) and moved into the header
 * on 2026-10-08 at the owner's request: just left of the navigation, where a
 * reader looks for the page's controls rather than at the bottom of a long
 * article. Both shells render it in the same place, so it is on every page, and
 * on the admin side it sits OUTSIDE the sign-in gate - the switch belongs to
 * whoever is looking, and the reader who followed "Manage" and met the sign-in
 * card is looking too.
 *
 * ONE PER PAGE. useColorScheme() keeps the choice in component state and writes
 * <html>'s attribute from it, so a second mounted switch would hold its own copy
 * of the choice and could disagree with the first. That is why the theme
 * thumbnails on the Settings page draw the header without it.
 *
 * Two buttons in one group, the pressed one showing the side the page is on.
 * aria-pressed on each button rather than one role="switch": a switch named
 * "Dark mode" that reads "off" says nothing about what off looks like, whereas
 * "Light, pressed" and "Dark" name both states. role="group" with a label gives a
 * screen reader the question the two buttons answer. Neither is ever disabled:
 * clicking the side already showing is harmless, and it pins that side - the one
 * way a reader still on the browser's setting can say "keep this one".
 *
 * The words are the chosen language's (S48): "Lys" and "Mørk" in Danish. The
 * language dropdown sits just left of this switch (LanguageSwitch.tsx).
 */

import { useColorScheme } from './ColorScheme.js';
import { useMessages } from '../i18n/language.js';

export function ColorSchemeSwitch(): JSX.Element {
  const { scheme, choose } = useColorScheme();
  const t = useMessages();

  return (
    <div className="scheme-switch" role="group" aria-label={t.appearance.label}>
      <button type="button" aria-pressed={scheme === 'light'} onClick={() => choose('light')}>
        {t.appearance.light}
      </button>
      <button type="button" aria-pressed={scheme === 'dark'} onClick={() => choose('dark')}>
        {t.appearance.dark}
      </button>
    </div>
  );
}
